import { useCallback } from 'react'
import { Ingredient } from '../../types/catalog'
import { ActionsCell, TD, TR } from '../../components/ui/Table'
import { Badge } from '../../components/ui/Badge'
import { Button } from '../../components/ui/Button'

interface Props {
  item: Ingredient
  onEdit: (item: Ingredient) => void
  onDelete: (item: Ingredient) => void
}
export function IngredientRow({ item, onEdit, onDelete }: Props) {
  const handleEdit = useCallback(() => onEdit(item), [item, onEdit])
  const handleDelete = useCallback(() => onDelete(item), [item, onDelete])

  return (
    <TR>
      <TD>{item.translations.find(t => t.locale === 'en')?.name ?? '—'}</TD>
      <TD>{item.translations.find(t => t.locale === 'es')?.name ?? '—'}</TD>
      <TD>
        <Badge color="purple">
          {item.foodGroup.translations.find(t => t.locale === 'en')?.name ?? item.foodGroup.code}
        </Badge>
      </TD>
      <TD>
        <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
          {item.seasons.map(s => (
            <Badge key={s.id} color="green">
              {s.translations.find(t => t.locale === 'en')?.name ?? s.code}
            </Badge>
          ))}
          {item.seasons.length === 0 && <span style={{ fontSize: 12, color: '#c4aed4' }}>—</span>}
        </div>
      </TD>
      <TD>
        <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
          {item.allergens.map(a => (
            <Badge key={a.id} color={a.presenceType === 'contains' ? 'red' : 'amber'}>
              {a.allergen.translations.find(t => t.locale === 'en')?.name ?? a.allergen.code}
            </Badge>
          ))}
          {item.allergens.length === 0 && <span style={{ fontSize: 12, color: '#c4aed4' }}>—</span>}
        </div>
      </TD>
      <ActionsCell>
        <Button variant="ghost" size="sm" onClick={handleEdit}>
          Edit
        </Button>
        <Button variant="danger" size="sm" onClick={handleDelete}>
          Delete
        </Button>
      </ActionsCell>
    </TR>
  )
}
